import React from 'react';
import PropTypes from 'prop-types';

// A fact box in the app preview: a title and text on a shaded background
const FactBoxPreview = ({ title, text }) => {
  if (!title && !text) {
    return null;
  }
  return (
    <div className="app-preview-factbox">
      {title ? <h4>{title}</h4> : null}
      {text ? (
        <div
          className="app-preview-html"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      ) : null}
    </div>
  );
};

FactBoxPreview.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
};

FactBoxPreview.defaultProps = {
  title: '',
  text: '',
};

export default FactBoxPreview;
